module.exports = __webpack_public_path__ + "static/media/华浦社区.c80ddf46.jpg";